import { Material } from "@/models/material.model";
import { QueryParams } from "@/models/query-params.model";
import { MaterialsRest } from "@/services/rest/materials.rest";
import { ObjectivesRest } from "@/services/rest/objectives.rest";
import { QuizRest } from "@/services/rest/quiz.rest";
import { GenericsUtils } from "@/utils/generics.util";
import { BehaviorSubject, last, map, take } from "rxjs";

export class ObjectiveService {
  constructor(
    private _objectives = new ObjectivesRest(),
    private _materials = new MaterialsRest(),
    private _quiz = new QuizRest(),
    private _generics = new GenericsUtils()
  ) {}

  private objective$ = new BehaviorSubject<any>([]);
  objective = this.objective$.asObservable();
  private objectives$ = new BehaviorSubject<any>([]);
  objectives = this.objectives$.asObservable();
  private materials$ = new BehaviorSubject<any>([]);
  materials = this.materials$.asObservable();
  private quiz$ = new BehaviorSubject<any>([]);
  quiz = this.quiz$.asObservable();
  private questions$ = new BehaviorSubject<any>([]);
  questions = this.questions$.asObservable();
  private questionsAbstract$ = new BehaviorSubject<any>([]);
  questionsAbstract = this.questionsAbstract$.asObservable();

  getObjectiveById(chapterId: string, trailId: string): void {
    this._objectives
      .getObjectiveById(chapterId, trailId)
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          this.objective$.next(response);
        },
      });
  }

  getObjectives(chapterId: string, params?: QueryParams): void {
    this._objectives
      .getObjectives(chapterId, params)
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          this.objectives$.next(response);
        },
      });
  }

  getMaterialsFromObjective(objectiveId: string, params: QueryParams): void {
    this._materials
      .getObjectsByLearningObjective(objectiveId, params)
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          response.content = this.sortByLearningGroupType(response.content);
          this.materials$.next(response);
        },
      });
  }

  getQuizByTeacher(objectiveId: string): void {
    this._quiz
      .getQuizByTeacher(objectiveId)
      .pipe(
        take(1),
        map((e) => {
          const totalMs = e.duration * 1000;
          const result = new Date(totalMs).toISOString().slice(11, 19);
          e.duration = result;
          return e;
        })
      )
      .subscribe({
        next: (response) => {
          this.quiz$.next(response);
        },
        error: (error) => {
          this.quiz$.next(null);
        },
      });
  }

  getQuestionsByQuiz(quizId: string, params: QueryParams): void {
    this._quiz
      .getQuestionsByQuiz(quizId, params)
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          this.questionsAbstract$.next(response);
        },
      });
  }
  getQuestionDefaultByQuiz(quizId: string, params: QueryParams): void {
    this._quiz
      .getQuestionsDefaultByQuiz(quizId, params)
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          this.questions$.next(response);
        },
      });
  }
  sortByLearningGroupType(materials: Material[]): Material[] {
    const priorities = {
      MOTIVATION: 0,
      INTRODUCTION: 1,
      DEVELOPMENT: 2,
      CLOSURE: 3,
    };
    materials.sort((a, b) => {
      const priorityA = priorities[a.learningGroupType];
      const priorityB = priorities[b.learningGroupType];
      return priorityA - priorityB;
    });
    return materials;
  }
  updateObjective(chapterId: string, objectiveId: string, data: any) {
    this._objectives
      .updateObjective(chapterId, objectiveId, data)
      .subscribe({ next: () => {}, error: (e) => {} });
  }
}
